import React from 'react'
function Universe() {
    return ( 
        <div className="container">
            <div className="row text-center mt-5">
                <h1>
                    The Zerodha Universe
                </h1>
                <p  className=" mt-3 text-muted">
                    Extend your trading and investment experience even further with our partner platforms.
                </p>

            </div>
            <div className="row mt-5 text-center ">
                <div className="col ">
                    <img src="media/images/Smallcaselogo.png" alt="Smallcase" style={{ width: "60%" }} />
                    <p className='mb-5 mt-2 text-muted'>Thermatic investment platform</p>
                    <img src="media/images/ZerodhaFundhouse.png" alt="Smallcase" style={{ width: "60%" }} />
                    <p className='mt-2 text-muted'>Asset management</p>
                </div>


                <div className="col  ">
                    <img src="media/images/Streaklogo.png" alt="Smallcase" style={{ width: "60%" }} />
                    <p className=' mt-2 mb-5 text-muted'>Algo & strategy platform</p>
                    <img src="media/images/goldenpiLogo.png" alt="Smallcase" style={{ width: "60%" }} />
                    <p className='mt-2 text-muted'>Bonds trading platform</p>
                </div>


                <div className="col  ">
                    <img src="media/images/Smallcaselogo.png" alt="Smallcase" style={{ width: "60%" }} />
                    <p className=' mt-2 mb-5 text-muted'>Thermatic investment platform</p>
                    <img src="media/images/ZerodhaFundhouse.png" alt="Smallcase" style={{ width: "60%" }} />
                    <p className='mt-2 text-muted'>Asset management</p>
                </div>
            </div>
            <div className="row mt-5 mb-5 text-center">
                <button className='mt-3 p-2 mb-5 fs-5 btn btn-primary' style={{width:'30%',margin:"0 auto "}}>Signup Now</button>
            </div>
        </div>
     );
}

export default Universe;